import axios from 'axios';

/*
*  This file contains all axios calls related links operations
*/

export const loadLinks = async (funnelId) => {
    const { data } = await axios.get(`/app/funnel/getLinks?funnelId=${funnelId}`);

    return data;
};

export const saveLink = async (funnelId, campaignLinkId, payload) => {
    const { data } = await axios.put(`/app/funnel/${funnelId}/links/${campaignLinkId}`, payload);

    return data;
};

export const deleteLink = async (campaignLinkId) => {
    await axios.delete(`/app/funnel/link/${campaignLinkId}`);
};

export const checkMarketingEmailIdsUsingLinks = async (campaignLinkId) => {
    const { data } = await axios.get(`/app/funnel/marketingEmailIds/link/${campaignLinkId}`);

    return data;
};
